module.exports = __webpack_public_path__ + "static/softwareplatform_button-9c8d2c5c1e51d011b02e6f30b7e328ed.png";